type Key = 'password' | 'draftDestination' | 'isDraftDestValid';

type Value = string;

interface IMemoryStore {
  memoryStore: Record<Key, Value>;
  getItem: (key: Key) => Value;
  setItem: (name: Key, value: Value) => void;
  removeItem: (name: Key) => void;
}

class MemoryStore implements IMemoryStore {
  memoryStore: Record<Key, Value>;

  constructor() {
    this.memoryStore = {} as Record<Key, Value>;
  }

  getItem(name: Key) {
    if (this.memoryStore[name]) {
      return this.memoryStore[name] || '';
    }
    return '';
  }

  setItem(name: Key, value: Value) {
    this.memoryStore[name] = value;
  }

  removeItem(name: Key) {
    if (this.getItem(name)) {
      delete this.memoryStore[name];
    }
  }
}

export const memoryStore = new MemoryStore();
